var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0634 0.98819H1.80938C0.811563 0.98819 0 1.79975 0 2.79756V10.9069C0 11.291 0.434344 11.5075 0.740937 11.2885L3.31813 9.44975C3.53437 9.29569 3.78875 9.21413 4.05438 9.21413H9.72281C10.7206 9.21413 11.5322 8.40257 11.5322 7.40475V1.45694C11.5322 1.19819 11.3222 0.98819 11.0634 0.98819ZM8.78656 6.66663H3.37063C3.11188 6.66663 2.90188 6.45694 2.90188 6.19788C2.90188 5.93913 3.11188 5.72913 3.37063 5.72913H8.78656C9.04531 5.72913 9.25531 5.93913 9.25531 6.19788C9.25531 6.45694 9.04531 6.66663 8.78656 6.66663ZM8.78656 4.47913H3.37063C3.11188 4.47913 2.90188 4.26944 2.90188 4.01038C2.90188 3.75163 3.11188 3.54163 3.37063 3.54163H8.78656C9.04531 3.54163 9.25531 3.75163 9.25531 4.01038C9.25531 4.26944 9.04531 4.47913 8.78656 4.47913Z",
    fill: "url(#paint0_linear_10_1334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.4335V14.5426C16 14.924 15.5678 15.1447 15.259 14.9241L12.6818 13.0857C12.4656 12.9316 12.2112 12.8501 11.9456 12.8501H6.27715C5.27934 12.8501 4.46777 12.0382 4.46777 11.0404V10.1516H9.72277C11.2375 10.1516 12.4696 8.91943 12.4696 7.40475V4.62381H14.1906C15.1884 4.62381 16 5.43568 16 6.4335Z",
    fill: "url(#paint1_linear_10_1334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1334",
    x1: 5.76609,
    y1: 0.98819,
    x2: 5.76609,
    y2: 11.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1334",
    x1: 10.2339,
    y1: 4.62381,
    x2: 10.2339,
    y2: 15.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgSel);
export default __webpack_public_path__ + "static/media/msgSel.fe7d96e71473252908c12afc41db2662.svg";
export { ForwardRef as ReactComponent };